module.exports = __webpack_public_path__ + "img/合作伙伴-2-1.f85452e1.png";